export const useUserType = (userSocialProfile) => {
    if (!userSocialProfile || !userSocialProfile.userRoles?.length) {
        return {
            isFitness: false,
            isWellness: false,
            isOutdoor: false,
            isDive: false,
            isMarine: false,
            isRaceEventProvider: false
        };
    }

    const { userRoles } = userSocialProfile;
    const hasRole = (roles, key) => roles.includes(key);

    return {
        isFitness: hasRole(userRoles, 'ROLE_FITNESS_USER'),
        isWellness: hasRole(userRoles, 'ROLE_WELLNESS_USER'),
        isOutdoor: hasRole(userRoles, 'ROLE_OUTDOOR_USER'),
        isDive: hasRole(userRoles, 'ROLE_DIVE_USER'),
        isMarine: hasRole(userRoles, 'ROLE_MARINE_USER'),
        isRaceEventProvider: hasRole(userRoles, 'ROLE_RACE_EVENT_PROVIDER')
    };
};

/**
 * Creates a menu item.
 *
 * @param {Object} options - The options for creating the menu item.
 * @param {string} options.title - The title of the menu item.
 * @param {string} [options.translationNamespace] - The translation namespace for the title.
 * @param {string} options.icon - The icon for the menu item.
 * @param {string} options.url - The URL for the menu item.
 * @param {number} options.order - The order of the menu item.
 * @param {boolean} [options.disabled=false] - Whether the menu item is disabled.
 * @param {boolean} [options.condition=true] - The condition to include the menu item.
 * @param {...Object} rest - Additional properties for the menu item.
 * @returns {Array<Object>} The created menu item.
 */
export const createMenuItem = ({ title, disabled = false, condition = true, menuItems, ...rest }) => {
    return condition ? [{ title, disabled, menuItems: menuItems ? menuItems.flat() : undefined, ...rest }] : [];
};
